import { useMapContext, } from "./hooks"
import { react } from "../../../omnia"

interface Props {
    selectedFieldId?: number
    disableUi: boolean
}


export function MapView({ selectedFieldId, disableUi }: Props) {

    const context = useMapContext(selectedFieldId, disableUi)

    if (!context) {
        return null
    }

    return <div className="map-view">

        <react.MapView map={context.map} />

    </div>
}
